import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    Button,
    Checkbox,
    TextField,
    Breadcrumbs,
    Link,
    Chip,
} from "@mui/material";
import HeaderDashboard from "../../components/HeaderDashboard";
import { useUser } from "../../../contexts/UserContext";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from "react-router-dom";
import ModalNotificacao from "./ModalNotificacao";
import axios from "axios";
import ModalAssinaturaCancelada from "./ModalAssinaturaCancelada";
import Loading from "../../components/Loading";
import { FormatToBrl } from "../../../utils/FormatToBrl";
import { gerarLinkWhatsApp } from "../../../utils/WhatsappLink";
import HomeIcon from '@mui/icons-material/Home';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import SentimentDissatisfiedOutlinedIcon from '@mui/icons-material/SentimentDissatisfiedOutlined';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';

const cardSx = {
    backgroundColor: "#fff",
    border: "1px solid #e5e7eb",
    borderRadius: "12px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
    p: { xs: 2, md: 3 },
};

const motivos = [
    "Preço alto",
    "Não estou usando o serviço",
    "Encontrei outra solução",
    "Problemas técnicos",
    "Insatisfação com o suporte"
];

const Alternativa = ({ icone, titulo, descricao, onClick }) => (
    <Box
        onClick={onClick}
        sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            backgroundColor: "rgba(255, 255, 255, 0.06)",
            borderRadius: "10px",
            p: 1.5,
            cursor: "pointer",
            transition: "background-color 0.2s ease",
            "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.12)" },
        }}
    >
        <Box sx={{ width: 32, height: 32, borderRadius: "8px", backgroundColor: "rgba(255, 200, 69, 0.15)", color: "#ffc845", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, "& svg": { fontSize: 18 } }}>
            {icone}
        </Box>
        <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#fff" }}>{titulo}</Typography>
            <Typography sx={{ fontSize: 11, color: "#94a3b8" }}>{descricao}</Typography>
        </Box>
        <ChevronRightIcon sx={{ fontSize: 18, color: "#94a3b8" }} />
    </Box>
);

const CancelarAssinatura = () => {
    const { user, fetchUser } = useUser();
    const navigate = useNavigate();
    const [userActive, setUserActive] = useState(true);
    const [openModalNotificacao, setOpenModalNotificacao] = useState(false);
    const [notificacoes, setNotificacoes] = useState([]);

    const [motivosSelecionados, setMotivosSelecionados] = useState([]);
    const [outroMotivo, setOutroMotivo] = useState("");
    const [erroValidacao, setErroValidacao] = useState(false);
    const [mensagemErro, setMensagemErro] = useState("");
    const [openModalAssinaturaCancelada, setOpenModalAssinaturaCancelada] = useState(false);
    const [enviando, setEnviando] = useState(false);

    useEffect(() => {
        const hasFaturasVencidas = user?.faturas?.vencidas?.length > 0;
        setUserActive(!hasFaturasVencidas);
    }, [user]);

    useEffect(() => {
        const getNotify = async () => {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/buscarNotificacoes`,
                { email: localStorage.getItem("email") },
                {
                    headers: {
                        Authorization: `${localStorage.getItem("token")}`
                    }
                }
            );

            if (response.data.status === 200) {
                setNotificacoes(response.data.notificacoes);
            }
        };

        getNotify();
    }, []);

    const handleCheckboxChange = (motivo) => {
        if (motivosSelecionados.includes(motivo)) {
            setMotivosSelecionados(prev => prev.filter(m => m !== motivo));
        } else {
            setMotivosSelecionados(prev => [...prev, motivo]);
        }
        setErroValidacao(false);
    };

    const handleCancelar = async () => {
        if (motivosSelecionados.length === 0 && outroMotivo.trim() === "") {
            setErroValidacao(true);
            setMensagemErro("Por favor, selecione ou informe ao menos um motivo para o cancelamento.");
            return;
        }

        setErroValidacao(false);
        setMensagemErro("");

        const dadosCancelamento = {
            motivosSelecionados,
            outroMotivo: outroMotivo.trim()
        };

        setEnviando(true);
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/cancelarAssinatura`,
                { ...dadosCancelamento, idAssinaturaAsaas: user?.assinatura?.idAssinaturaAsaas },
                {
                    headers: {
                        Authorization: `${localStorage.getItem("token")}`
                    }
                }
            );

            if (response.status === 200) {
                fetchUser();
                setOpenModalAssinaturaCancelada(true);
            } else {
                setErroValidacao(true);
                setMensagemErro("Não foi possível cancelar a assinatura. Tente novamente mais tarde.");
            }
        } catch (error) {
            console.error("Erro ao cancelar assinatura:", error);
            setErroValidacao(true);
            setMensagemErro("Não foi possível cancelar a assinatura. Tente novamente mais tarde.");
        } finally {
            setEnviando(false);
        }
    };


    return (
        <>
            <HeaderDashboard
                userActive={userActive}
                setOpenModalNotificacao={setOpenModalNotificacao}
                notificacoes={notificacoes.length}
            />
            <Box sx={{ pt: "80px", pb: 4, px: { xs: 2, md: "5%" }, minHeight: "100vh" }}>
                <Box
                    sx={{
                        ...cardSx,
                        display: "flex",
                        flexDirection: { xs: "column", md: "row" },
                        alignItems: { xs: "stretch", md: "center" },
                        justifyContent: "space-between",
                        gap: 2,
                    }}
                >
                    <Box>
                        <Breadcrumbs aria-label="breadcrumb" sx={{ fontSize: 12, "& .MuiBreadcrumbs-separator": { mx: 0.5 } }}>
                            <Link
                                underline="hover"
                                sx={{ display: 'flex', alignItems: 'center', cursor: "pointer", fontSize: 12, color: "#6b7280" }}
                                onClick={() => navigate("../Dashboard")}
                            >
                                <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                Dashboard
                            </Link>
                            <Link
                                underline="hover"
                                sx={{ display: 'flex', alignItems: 'center', cursor: "pointer", fontSize: 12, color: "#6b7280" }}
                                onClick={() => navigate("../Dashboard/Assinatura")}
                            >
                                <AssignmentTurnedInIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                Assinatura & Cobranças
                            </Link>
                            <Typography sx={{ fontSize: 12, color: "#111827", fontWeight: 600, display: 'flex', alignItems: 'center' }}>
                                <HighlightOffIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                Cancelar Assinatura
                            </Typography>
                        </Breadcrumbs>
                        <Typography sx={{ mt: 1, fontSize: { xs: 20, md: 24 }, fontWeight: 700, color: "#111827" }}>
                            Cancelamento de Assinatura
                        </Typography>
                        <Typography sx={{ mt: 0.5, fontSize: 14, color: "#4b5563" }}>
                            Sentiremos sua falta! Antes de concluir, conte pra gente o motivo da sua decisão.
                        </Typography>
                    </Box>
                    <Button
                        startIcon={<ArrowBackIcon />}
                        onClick={() => navigate("../Dashboard/Assinatura")}
                        sx={{ alignSelf: { xs: "flex-start", md: "center" }, textTransform: "none", fontSize: 13, fontWeight: 600, color: "#374151", backgroundColor: "#f3f4f6", borderRadius: "8px", px: 2, "&:hover": { backgroundColor: "#e5e7eb" } }}
                    >
                        Voltar
                    </Button>
                </Box>

                <Box
                    sx={{
                        mt: 2,
                        display: "grid",
                        gridTemplateColumns: { xs: "1fr", md: "minmax(0, 3fr) minmax(0, 2fr)" },
                        gap: 2,
                        alignItems: "start",
                    }}
                >
                    {/* Motivos */}
                    <Box sx={cardSx}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2 }}>
                            <Box sx={{ width: 36, height: 36, borderRadius: "8px", backgroundColor: "#f3f4f6", color: "#374151", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                <SentimentDissatisfiedOutlinedIcon sx={{ fontSize: 20 }} />
                            </Box>
                            <Box>
                                <Typography sx={{ fontSize: 16, fontWeight: 700, color: "#111827" }}>Por que você está cancelando?</Typography>
                                <Typography sx={{ fontSize: 12, color: "#6b7280" }}>
                                    Sua opinião nos ajuda a melhorar continuamente. Selecione um ou mais motivos.
                                </Typography>
                            </Box>
                        </Box>

                        <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" }, gap: 1 }}>
                            {motivos.map((motivo) => {
                                const selecionado = motivosSelecionados.includes(motivo);
                                return (
                                    <Box
                                        key={motivo}
                                        component="label"
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 1,
                                            border: "1px solid",
                                            borderColor: selecionado ? "#0b243d" : "#e5e7eb",
                                            backgroundColor: selecionado ? "#f1f5f9" : "#fff",
                                            borderRadius: "10px",
                                            pl: 0.5,
                                            pr: 1.5,
                                            py: 0.5,
                                            cursor: "pointer",
                                            transition: "all 0.15s ease",
                                            "&:hover": { borderColor: selecionado ? "#0b243d" : "#cbd5e1" },
                                        }}
                                    >
                                        <Checkbox
                                            size="small"
                                            checked={selecionado}
                                            onChange={() => handleCheckboxChange(motivo)}
                                            sx={{ "&.Mui-checked": { color: "#0b243d" } }}
                                        />
                                        <Typography sx={{ fontSize: 13, fontWeight: selecionado ? 600 : 500, color: "#111827" }}>{motivo}</Typography>
                                    </Box>
                                );
                            })}
                        </Box>

                        <TextField
                            label="Outro motivo (opcional)"
                            placeholder="Conte com mais detalhes, se quiser..."
                            variant="outlined"
                            fullWidth
                            multiline
                            rows={3}
                            value={outroMotivo}
                            onChange={(e) => { setOutroMotivo(e.target.value); setErroValidacao(false); }}
                            sx={{ mt: 2, "& .MuiOutlinedInput-root": { borderRadius: "8px", backgroundColor: "#fff", fontSize: 14 } }}
                        />

                        {erroValidacao && (
                            <Box sx={{ mt: 1.5, display: "flex", alignItems: "center", gap: 1, backgroundColor: "#fee2e2", color: "#b91c1c", borderRadius: "8px", px: 1.5, py: 1 }}>
                                <ErrorOutlineIcon sx={{ fontSize: 18 }} />
                                <Typography sx={{ fontSize: 13, fontWeight: 500 }}>{mensagemErro}</Typography>
                            </Box>
                        )}

                        <Box sx={{ mt: 3, pt: 2, borderTop: "1px solid #f3f4f6", display: "flex", flexDirection: { xs: "column-reverse", sm: "row" }, justifyContent: "flex-end", gap: 1 }}>
                            <Button
                                variant="outlined"
                                disabled={enviando}
                                onClick={handleCancelar}
                                sx={{ textTransform: "none", fontSize: 13, fontWeight: 600, color: "#b91c1c", borderColor: "#fecaca", borderRadius: "8px", px: 2.5, "&:hover": { backgroundColor: "#fef2f2", borderColor: "#fca5a5" } }}
                            >
                                {enviando ? "Cancelando..." : "Confirmar cancelamento"}
                            </Button>
                            <Button
                                variant="contained"
                                startIcon={<FavoriteBorderIcon />}
                                onClick={() => navigate("../Dashboard/Assinatura")}
                                sx={{ textTransform: "none", fontSize: 13, fontWeight: 700, color: "#111827", backgroundColor: "#ffc845", borderRadius: "8px", boxShadow: "none", px: 2.5, "&:hover": { backgroundColor: "#f5b82e", boxShadow: "none" } }}
                            >
                                Manter minha assinatura
                            </Button>
                        </Box>
                    </Box>

                    {/* Plano atual e alternativas */}
                    <Box sx={{ ...cardSx, backgroundColor: "#0b243d", border: "none", color: "#fff", position: { md: "sticky" }, top: { md: 80 } }}>
                        <Chip
                            label="Seu plano"
                            size="small"
                            sx={{ backgroundColor: "rgba(255, 200, 69, 0.15)", color: "#ffc845", fontWeight: 700, fontSize: 10, height: 20, letterSpacing: 0.6, textTransform: "uppercase" }}
                        />
                        <Box sx={{ mt: 2, display: "flex", alignItems: "center", gap: 1.5 }}>
                            <Box sx={{ width: 44, height: 44, borderRadius: "10px", backgroundColor: "rgba(255, 255, 255, 0.08)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                <WorkspacePremiumIcon sx={{ color: "#ffc845", fontSize: 26 }} />
                            </Box>
                            <Box sx={{ minWidth: 0 }}>
                                <Typography sx={{ fontSize: 17, fontWeight: 700 }}>{user?.plano?.nome || "Plano não definido"}</Typography>
                                {user?.asaas?.value ? (
                                    <Typography sx={{ fontSize: 13, color: "#cbd5e1" }}>{FormatToBrl(user.asaas.value)} por cobrança</Typography>
                                ) : null}
                            </Box>
                        </Box>

                        <Typography sx={{ mt: 3, mb: 1.5, fontSize: 14, fontWeight: 700 }}>
                            Antes de cancelar, que tal...
                        </Typography>
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                            <Alternativa
                                icone={<SwapHorizIcon />}
                                titulo="Mudar de plano"
                                descricao="Encontre um plano mais adequado ao seu momento"
                                onClick={() => navigate("../Dashboard/MudarPlano")}
                            />
                            <Alternativa
                                icone={<WhatsAppIcon />}
                                titulo="Falar com a nossa equipe"
                                descricao="Tire dúvidas ou resolva o que está te incomodando"
                                onClick={() => window.open(gerarLinkWhatsApp("Olá, estou pensando em cancelar minha assinatura e gostaria de conversar antes."), "_blank")}
                            />
                        </Box>
                    </Box>
                </Box>
            </Box>
            <ModalNotificacao
                openModalNotificacao={openModalNotificacao}
                onClose={() => setOpenModalNotificacao(false)}
                notificacoes={notificacoes}
            />
            <ModalAssinaturaCancelada
                openModalAssinaturaCancelada={openModalAssinaturaCancelada}
                setOpenModalAssinaturaCancelada={setOpenModalAssinaturaCancelada}
            />
            <Loading open={enviando} />
        </>
    );
};

export default CancelarAssinatura;
